module.exports = __webpack_public_path__ + "img/cg_ruoyi_lolita.617a0319.jpg";